var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-o-charts"},[_c('el-row',{attrs:{"gutter":35}},[_c('el-col',{attrs:{"span":24}},[_c('chartsc',{attrs:{"chart-data":_vm.chartData}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }